import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "com_problem"
};
const _hoisted_2 = {
  class: "class"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["innerHTML"];
import { ref, computed } from 'vue';
import { classList } from './problem_json.js';
export default {
  __name: 'problem',
  setup(__props) {
    const classId = ref(1);

    //切换
    const classChange = id => {
      if (id == classId.value) return;
      classId.value = id;
    };

    // 计算属性
    const content = computed(() => {
      return classList.find(item => item.id === classId.value)?.content || '';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => classChange(item.id),
          key: index,
          class: _normalizeClass(classId.value == item.id ? 'list checked' : 'list')
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))]), _createElementVNode("div", {
        innerHTML: content.value,
        class: "content"
      }, null, 8, _hoisted_4)]);
    };
  }
};